const merge = require('lodash/merge');

const config = {
  all: {
    env: process.env.REACT_APP_STAGE || 'development',
    isBrowser: typeof window !== 'undefined',
    isServer: typeof window === 'undefined',
  },
  testing: {
    apiUrl: 'https://testing-api.mintacademyhk.com/api',
    authApiUrl: 'https://testing-api.mintacademyhk.com/auth',
  },
  development: {
    apiUrl: process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : 'http://localhost:3000/api',
    authApiUrl: process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/auth` : 'http://localhost:3000/auth',
  },
  staging: {
    apiUrl: 'https://test.mintacademyhk.com/api',
    authApiUrl: 'https://test.mintacademyhk.com/auth',
  },
  production: {
    apiUrl: 'https://api.mintacademyhk.com/api',
    authApiUrl: 'https://api.mintacademyhk.com/auth',
  },
};

module.exports = merge(config.all, config[config.all.env]);
